import types from './types';

const INITIAL_STATE = {
  isFetching: false,
  isFetchingDiags: false,
  isFetchingDetails: false,
  isSavingAdditional: false,
  isUpdating: false,
  isDeleting: false,

  result: [],
};

const eligibilityHCCReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.GET_HCC_REQUEST:
      return {
        ...state,
        result: [],
        isFetching: true,
      };

    case types.GET_HCC_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetching: false,
      };

    case types.GET_HCC_FAILURE:
      return {
        ...state,
        result: [],
        isFetching: false,
      };

    case types.GET_MEMBER_HCC_AND_DIAGS_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingDiags: true,
      };

    case types.GET_MEMBER_HCC_AND_DIAGS_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingDiags: false,
      };

    case types.GET_MEMBER_HCC_AND_DIAGS_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingDiags: false,
      };

    case types.GET_HCC_DETAILS_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingDetails: true,
      };

    case types.GET_HCC_DETAILS_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingDetails: false,
      };

    case types.GET_HCC_DETAILS_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingDetails: false,
      };

    case types.UPDATE_HCC_STATUS_AND_COMMENT_REQUEST:
      return {
        ...state,
        result: [],
        isUpdating: true,
      };

    case types.UPDATE_HCC_STATUS_AND_COMMENT_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isUpdating: false,
      };

    case types.UPDATE_HCC_STATUS_AND_COMMENT_FAILURE:
      return {
        ...state,
        result: [],
        isUpdating: false,
      };

    case types.DELETE_HCC_DOC_REQUEST:
      return {
        ...state,
        result: [],
        isDeleting: true,
      };

    case types.DELETE_HCC_DOC_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isDeleting: false,
      };

    case types.DELETE_HCC_DOC_FAILURE:
      return {
        ...state,
        result: [],
        isDeleting: false,
      };

    default:
      return state;
  }
};

export default eligibilityHCCReducer;
